import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormulariosService } from 'src/app/services/formularios.service';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';

@Component({
  selector: 'app-contact-panel',
  templateUrl: './contact-panel.component.html',
  styleUrls: ['./contact-panel.component.scss']
})
export class ContactPanelComponent {

  public sent: boolean = false;
  contactForm: FormGroup;
  emailUser!: string;
  problem!: string;

  error: boolean = false;

  constructor(private formBuilder: FormBuilder, private formularioService: FormulariosService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ContactPanelComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    this.emailUser = this.data.email;
    this.contactForm = this.formBuilder.group({
      email: [this.emailUser, [Validators.required, Validators.email]],
      subject: ['', [Validators.required]],
      problem: ['Otros', [Validators.required]],
      body: ['', [Validators.required]],
    });
  }

  sendContact() {
    if (this.contactForm.invalid) {
      this.error = true;
      return;
    }
    const confirmRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: '¿Estás seguro de que quieres enviar la solicitud de cambios?',
        btnCancel: true,
        textButton: 'Enviar',
      }
    });
    confirmRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        const formValue = this.contactForm.value;
        const payload = {
          email: formValue.email,
          title: formValue.subject,
          description: formValue.body,
          category: formValue.problem,
        };
        var message = JSON.stringify(payload);
        this.formularioService.sendMessage(message).subscribe(
          (response: any) => {
            if (response && response.code === '200') {
              this.dialogRef.close(response);
            } else {
              this.dialogRef.close({ status: 'error' });
            }
          }
        );
      }
    });
  }
}
